import { Trans, useTranslation } from "react-i18next";
import { useAppSelector } from "redux/hooks";
import { convertTimeFrom24To12 } from "utils/hooks/useMoment";

const UTASLoginRight = () => {
  const { t } = useTranslation();
  const { keyDateHyperlink, maintenanceStartTime, maintenanceEndTime } = useAppSelector(
    state => state.properties.data
  );

  return (
    <div>
      <p className="text-center">
        <Trans
          components={[
            <a href={keyDateHyperlink} target="_blank">
              key dates
            </a>
          ]}
        >
          {t("login.placeholder")}
        </Trans>
      </p>
      <p className="text-center">
        <Trans>
          {t("login.placeholderInfo", {
            startTime: convertTimeFrom24To12(maintenanceStartTime),
            endTime: convertTimeFrom24To12(maintenanceEndTime)
          })}
        </Trans>
      </p>
    </div>
  );
};

export default UTASLoginRight;
